(function($) {

	$.fn.multiStageProgressBar = function(options) {
		// build main options before element iteration
		options = $.extend(true, {}, $.fn.multiStageProgressBar.defaults, options);

		return this.each(function() {
			var $this = $(this);
			// build element specific options
			$this.options = $.metadata ? $.extend(true, {}, options, $this.metadata()) : options;
			$this.options = $.fn.dataset ? $.extend(true, $this.options, $this.dataset()) : $this.options;

			if ($this.options['data']) {
				renderMultiStageProgressBar($this, $.parseJSON($this.options['data']));
			}

			if ($this.options['show-timer']) {
				initTimer($this);
			}

			if ($this.options['polling-url']) {
				initPolling($this);
			}
        });
	};
	//
	// plugin defaults
	//
	$.fn.multiStageProgressBar.defaults = {
		'show-timer': false,
		'timer-initial-seconds': 0,
		'polling-url': '',
		'polling-interval': 1000,
		'target-status': [],
		'data': {}
	};
    //
    // Private functions
    //
	function renderMultiStageProgressBar($multiStageProgressBar, data) {
		var status = data.status.toLowerCase();
		var stages = data.stages;

		var prevStagePassCount = data.maxCount;
		for (var i = 0; i < stages.length; i++) {
			var stage = stages[i];
			setStatus($multiStageProgressBar, i, '#' + stage.id, stage.message, stage.passCount, stage.failCount, prevStagePassCount, status);
			prevStagePassCount = stage.passCount;
		}

		if (data.messageOverride) {
			$('.multi-stage-progress-bar-summary').text(translate(data.messageOverride));
		}
	}

	function setStatus($multiStageProgressBar, i, progressNodeSelector, inProgressMessage, passCount, errorCount, maxCount, status) {
		var percentPass = calcPercentage(passCount, maxCount);
		var percentError = calcPercentage(errorCount, maxCount);
		var percentComplete = percentPass + percentError;

		var $item = $multiStageProgressBar.find(progressNodeSelector);

		if (i === 0) {
			var $stageProgressBar = $item.find('.stage-progress-bar');
			var margin = $stageProgressBar.css('margin-left');
			$stageProgressBar.css('margin-left', '0');
			$stageProgressBar.css('width', '+=' + margin);
		}

		if (percentComplete === 100) {
			var clazz = (passCount > 0) ? "completed" : "failed";
			$item.attr("class", clazz);
			$('.multi-stage-progress-bar-summary').text(translate(inProgressMessage));
		}
		else if (percentComplete > 0 || i === 0) {
			$item.attr("class", "in-progress");
			$('.multi-stage-progress-bar-summary').text(translate(inProgressMessage));
		}

		if (percentComplete === 0 && (status === 'aborted' || status === 'failed')) {
			$item.find('.stage-progress-bar-error').width("100%");
			$item.attr("class", "failed");
		}
		else {
			$item.find('.node-label').text(passCount);
			$item.find('.stage-progress-bar-pass').width(percentPass + "%");
			$item.find('.stage-progress-bar-error').width(percentError + "%");
		}
	}

	function calcPercentage(fraction, total) {
		if (total === 0) {
			return 0;
		}
		var percentage = fraction / total * 100;
		return percentage > 100 ? 100 : percentage;
	}

	function initPolling($multiStageProgressBar) {
		doPoll($multiStageProgressBar);
	}


	function doPoll($multiStageProgressBar) {
		$.ajax({
			type: "GET",
			dataType: "json",
			url: $multiStageProgressBar.options['polling-url'],
			success: function (data) {
				var status = data.status.toLowerCase();

				var targetStatuses = $.parseJSON($multiStageProgressBar.options['target-status']);
				if (($.inArray(status, targetStatuses) !== -1)) {
					setTimeout(function() { window.location.reload(true); }, 1000);
				}
				else {
					renderMultiStageProgressBar($multiStageProgressBar, data);
					setTimeout(function() { doPoll($multiStageProgressBar); }, $multiStageProgressBar.options['polling-interval']);
				}
			},
			failure: function(errMsg) {
				throw new Error(errMsg);
			}
		});
	}

	function initTimer($multiStageProgressBar) {
		$multiStageProgressBar.data("loadingTimeSoFar", $multiStageProgressBar.options['timer-initial-seconds'] * 1000);
		$multiStageProgressBar.data("startMillis", new Date().getTime());
		incTimer($multiStageProgressBar);
	}

	function incTimer($multiStageProgressBar) {
		var $loadingTimer = $multiStageProgressBar.find('.multi-stage-progress-bar-timer');
		var nowMillis = new Date().getTime();
		var elapsedSecs = Math.floor(((nowMillis - $multiStageProgressBar.data("startMillis")) + $multiStageProgressBar.data("loadingTimeSoFar")) / 1000);
		var minutes = Math.floor(elapsedSecs / 60) % 60;
		var hours = Math.floor(elapsedSecs / (60*60)) % 60;
		var seconds = elapsedSecs % 60;

		$loadingTimer.text(pad(hours) + ":" + pad(minutes) + ":" + pad(seconds));

		setTimeout(function() { incTimer($multiStageProgressBar); }, 1000);
	}

	function pad(n) {
		return (n < 10) ? "0" + n : n;
	}

})(jQuery);